import cn from 'classnames';
import styles from './flex.module.sass';
import withResponsiveStyles, {
    ResponsiveOrder,
    ResponsiveDirection,
    ResponsiveValue,
    ResponsiveItemCount,
} from '../hocs/ResponiseStyles/withResponsiveStyles';

// FlexWrapper component
interface FlexWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    gap?: ResponsiveValue; //'small' | 'medium' | 'large' | '4x';
    flexDirection?: 'column' | 'row';
    flexGrow?: boolean;
    itemCount?: ResponsiveItemCount;
    children: React.ReactNode;
    justifyContent?: 'center' | 'start' | 'end' | 'between' | 'around' | 'evenly';
    alignItems?: 'start' | 'end' | 'center';
    valign?: boolean;
    wrap?: boolean;
    sticky?: boolean;
    ref?: any;
}

const OriginalFlexWrapper = ({
    children,
    gap,
    itemCount,
    justifyContent,
    alignItems,
    flexDirection,
    flexGrow = false,
    valign = false,
    wrap = false,
    sticky = false,
    className,
    ...props
}: FlexWrapperProps) => {
    const classes = cn(
        cn(styles['flex-wrapper'], className),
        typeof flexDirection === 'string' && styles[`direction-${flexDirection}`],
        // itemCount && cn(styles[`basis-${itemCount}`], styles.basis),
        justifyContent && styles[`justify-${justifyContent}`],
        alignItems && styles[`align-items-${alignItems}`],
        flexGrow && styles['grow'],
        valign && styles['valign'],
        wrap && styles['wrap'],
        sticky && styles['sticky']
    );

    return (
        <div className={classes} {...props}>
            {children}
        </div>
    );
};

// FlexChild component
interface FlexChildProps extends React.HTMLAttributes<HTMLDivElement> {
    flexGrow?: boolean;
    order?: ResponsiveOrder;
    alignSelf?: 'start' | 'end' | 'center';
    justifyContent?: 'start' | 'end' | 'center';
    alignItems?: 'start' | 'end' | 'center';
}

const OriginalFlexChild = ({
    flexGrow,
    order,
    alignSelf,
    justifyContent,
    alignItems,
    className,
    ...props
}: FlexChildProps) => {
    const classes = cn(
        className,
        flexGrow && styles.grow,
        order && styles[`order-${order}`],
        alignSelf && `${styles[`align-self-${alignSelf}`]} ${styles[`align-self`]}`,
        alignItems && styles[`align-items-${alignItems}`],
        justifyContent && `${styles[`justify-content-${justifyContent}`]} ${styles[`justify-content`]}`
        // ... any other conditional classes here if needed
    );

    return <div className={classes} {...props} />;
};

// Apply the HOC to FlexWrapper
const FlexWrapper = withResponsiveStyles(OriginalFlexWrapper);

// Apply the HOC to FlexChild
const FlexChild = withResponsiveStyles(OriginalFlexChild);

// Export the enhanced components
export { FlexWrapper, FlexChild };
